var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoraires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 2.41179C28.9104 3.99162 31.1195 6.2639 32.6555 9.00025C34.1914 11.7366 35 14.8406 35 18.0002C35 21.1599 34.1913 24.2639 32.6554 27.0002C31.1194 29.7365 28.9102 32.0088 26.2498 33.5886C23.5894 35.1684 20.5716 36 17.4997 36C14.4278 36 11.41 35.1682 8.74971 33.5883C6.08939 32.0084 3.88026 29.7361 2.34436 26.9997C0.808465 24.2633 -7.80319e-05 21.1593 5.64839e-09 17.9997L0.00875021 17.4165C0.106756 14.3079 0.986209 11.2785 2.56137 8.62353C4.13653 5.96861 6.35364 3.77879 8.99656 2.26758C11.6395 0.756364 14.618 -0.0246792 17.6418 0.000594438C20.6655 0.0258681 23.6313 0.856596 26.25 2.41179ZM17.5 7.19975C17.0359 7.19975 16.5908 7.3894 16.2626 7.72696C15.9344 8.06452 15.75 8.52236 15.75 8.99974V17.9997C15.75 18.4771 15.9344 18.9349 16.2626 19.2725C16.5908 19.61 17.0359 19.7997 17.5 19.7997H23.625C24.0891 19.7997 24.5343 19.61 24.8624 19.2725C25.1906 18.9349 25.375 18.4771 25.375 17.9997C25.375 17.5223 25.1906 17.0645 24.8624 16.7269C24.5343 16.3893 24.0891 16.1997 23.625 16.1997H19.25V8.99974C19.2499 8.55886 19.0926 8.13334 18.8077 7.80388C18.5229 7.47442 18.1304 7.26394 17.7048 7.21235L17.5 7.19975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoraires);
export default __webpack_public_path__ + "static/media/horaires.6501c9359d76bf0e18f6545172bfce78.svg";
export { ForwardRef as ReactComponent };